import { render, staticRenderFns } from "./LDataCard.vue?vue&type=template&id=77026b1b&scoped=true"
import script from "./LDataCard.vue?vue&type=script&lang=js"
export * from "./LDataCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77026b1b",
  null
  
)

export default component.exports